__turbopack_context__.v({
  "className": "foundersgroteskregular_e67e2396-module__fZN76W__className",
});
